module.exports = __webpack_public_path__ + "static/media/sil-min.4518dc9f.png";